export default function defaultBrandIcon() {
    return (
      <svg
        style={{ marginBottom: "-3px" }}
        width="14"
        height="26"
        viewBox="0 0 17 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.49808 9.7258C9.50369 9.7259 10.4867 9.4408 11.323 8.9065C12.1591 8.3722 12.8109 7.6127 13.1958 6.7241C13.5806 5.8356 13.6814 4.8578 13.4853 3.9144C13.2891 2.97111 12.8049 2.10458 12.0938 1.42445C11.3828 0.744321 10.4768 0.281141 9.49052 0.0934713C8.50424 -0.0941987 7.4819 0.00208127 6.55282 0.370131C5.62374 0.738191 4.82964 1.36148 4.2709 2.16119C3.71225 2.9609 3.41406 3.9011 3.41406 4.8629C3.41406 6.1526 3.9496 7.3894 4.90304 8.3014C5.85648 9.2134 7.14962 9.7257 8.49808 9.7258Z"
          fill="#F8B400"
        />
        <path
          d="M17 10.834H11.8998L8.51574 15.1636L5.11601 10.834H0L5.95831 18.4016L0 25.9995H5.11601L8.51574 21.6533L11.8998 25.9995H17L11.0578 18.4016L17 10.834Z"
          fill="#0445A5"
        />
      </svg>
    );
  };